export const CALLING_APP_ID = 8;
export const VIS_FULL_RESOLUTION = 0;
export const VIS_THUMB_RESOLUTION = 1;

export const APP_NAME = 'Condition Capture';
